import React, { Component } from 'react';
import { Button } from '../Button';
import Modal from 'react-responsive-modal';
import { Gateway } from '../../BaseUrl';
import { Base64 } from 'js-base64';
import { Post } from '../../Ajax';

export class AddCard extends Component {
    displayName = AddCard.name

    _isMounted = false;
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            mandateSrc: "",
            loading: false
        }

        this.closeModal = this.closeModal.bind(this);
    }
    
    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    updateState(object, func = () => { }) {
        if (this._isMounted) {
            this.setState(object, func);
        }
    }

    async createCard() {
        try {
            this.updateState({ loading: true });

            const { isBorrower, personIds, summary, name } = this.props;
            var customerId = isBorrower ? summary.borrowerCustomerId : summary.guarantorCustomerId;
            var role = isBorrower ? "Borrower" : "Guarantor";

            let data = await Post(`${Gateway}/payments/Loan/${summary.loanReferenceNumber}/CreateCard/${role}/`, {
                AppId: summary.loanReferenceNumber,
                AgentName: `Customer: ${name.firstname} ${name.lastname}`,
                PersonId: personIds[0],
                Role: role,
                Source: "Servicing",
                CustomerId: customerId,
                IsBorrower: isBorrower
            }, "text", () => this.props.Logout());

            this.updateState({
                mandateSrc: Base64.decode(data).replace("320px", "420px"),
                open: true,
                loading: false
            });
        } catch (e) {
            console.error(e)

            this.updateState({
                mandateSrc: "",
                open: false,
                loading: false
            });
        }        
    }

    closeModal() {
        this.updateState({
            open: false
        }, () => this.props.onClose());
    }

    render() {
        const { open, mandateSrc, loading } = this.state;
        const { isButton, text } = this.props;
        const styles = { display: "flex", justifyContent: "space-between" };

        return (
            <div style={{ display: "inline-block" }}>
                {
                    isButton ?
                        <Button value={text} onClick={() => this.createCard()} type="button" loading={loading}/> :

                        <a onClick={(e) => { e.preventDefault(); this.createCard(); }}
                            style={{ textDecoration: "underline", fontWeight: 400, fontSize: "15px" }}>
                            {text} {loading && <i className="fas fa-spinner fa-spin"></i>}
                        </a>
                }
                {
                    open &&
                    <Modal open={open}
                        onClose={this.closeModal}
                        center
                        blockScroll={false}
                        classNames={{
                            overlay: styles.customOverlay,
                            modal: "slimpayModal",
                        }} >

                        {/*<h4 style={{ textAlign: "center" }}>Are you sure?</h4>*/}
                        <hr />
                        {/*<div dangerouslySetInnerHTML={{ __html: mandateSrc }} />*/}
                        <div>
                            <iframe
                                srcDoc={this.state.mandateSrc}
                                frameBorder='0'
                                scrolling='yes'
                                style={{ width: '700px', height: '50vh' }}
                            />
                        </div>
                    </Modal>
                }
            </div>
        );
    }
}

AddCard.defaultProps = {
    isButton: true,
    text: "Add Card",
    onClose: () => { }
}


// WEBPACK FOOTER //
// ./src/components/AddCard/AddCard.js